import React from 'react';
import { Switch, Route } from 'react-router-dom';
import ZonaDemandContainer from './PageContainer';

function LandingZonaDemand() {
  return (
    <>
      <Switch>
        <Route path='/zona-demand'>
          <ZonaDemandContainer />
        </Route>
      </Switch>
    </>
  );
}

export { LandingZonaDemand };
